import { render, staticRenderFns } from "./BarrelBreakdown.vue?vue&type=template&id=200495f6&"
import script from "./BarrelBreakdown.vue?vue&type=script&lang=ts&"
export * from "./BarrelBreakdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports